import { Node } from 'pdfmake/interfaces';
import { IPdfPageBreakFunc } from './pdf.type';

const keepSignatureInSamePageBreak: IPdfPageBreakFunc = (
  currentNode,
  followingNodesOnPage,
  nodesOnNextPage,
  previousNodesOnPage,
): boolean => {
  const firstNodeOnNextPage: Node = nodesOnNextPage[0];
  if (previousNodesOnPage.length <= 0 || nodesOnNextPage.length <= 0) {
    return false;
  }

  // Venues Inventory Uniform conventions: when the node has the style signature it is a signature node
  const isNextPageFistNodeKeepSamePage =
    Array.isArray(firstNodeOnNextPage?.style) ||
    typeof firstNodeOnNextPage.style === 'string'
      ? firstNodeOnNextPage.style.includes('signature')
      : false;

  const isCurrentNodeKeepSamePage =
    Array.isArray(currentNode?.style) || typeof currentNode.style === 'string'
      ? currentNode.style.includes('signature')
      : false;

  return isNextPageFistNodeKeepSamePage && isCurrentNodeKeepSamePage;
};

export { keepSignatureInSamePageBreak };
